import { sourceImage } from "../../utils/source-image.js";
import { getApiUrl } from "../../services/apiConfig.js";
/* Portal de consulta e gestão local. Não altera contas ou conteúdos. */
(function () {
  "use strict";

  const labels = {
    home: "Visão geral",
    cadastro: "Cadastrar aluno",
    turmas: "Turmas",
    reforco: "Reforço",
    vestibulares: "Vestibulares",
    simuladores: "Simuladores",
    olimpiadas: "Olimpíadas",
    pontuacao: "Pontuação",
    alunos: "Alunos",
    professores: "Professores",
    tarefas: "Tarefas",
    relatorios: "Relatórios",
    feed: "Feed",
    questoes: "Questões a resolver",
    bonus: "Bônus e penalidades",
    cardapio: "Cardápio",
    loja: "Recompensas",
    agendar: "Agendamentos",
    desafios: "Desafios",
    rankings: "Ranking",
    meritos: "Méritos",
    perfil: "Perfil da instituição",
    salas: "Salas",
    bloqueios: "Bloqueios",
    resgates: "Resgates",
  };
  const screens = {
    reforco: "conteudos",
    vestibulares: "vestibulares",
    simuladores: "simuladores-conteudo",
    olimpiadas: "olimpiada-conteudo",
    cadastro: "alunos",
    alunos: "alunos",
    turmas: "turmas",
    professores: "professores",
    tarefas: "tarefas",
    relatorios: "relatorios",
    pontuacao: "pontuacao",
    feed: "feed",
    questoes: "questoes",
    bonus: "bonus",
    cardapio: "cardapio",
    loja: "loja",
    agendar: "agendar",
    desafios: "desafios",
    rankings: "rankings",
    meritos: "meritos",
    perfil: "perfil",
    salas: "agendar",
    bloqueios: "agendar",
    resgates: "loja",
  };
  const libraries = ["reforco", "vestibulares", "simuladores", "olimpiadas"];
  const handleAction = (tag, cls, text) => {
    const createElementResult = document.createElement(tag);
    if (cls) createElementResult.className = cls;
    if (text !== undefined) createElementResult.textContent = text;
    return createElementResult;
  };
  const btn = (text, index, cls = "dp-button") => {
    const handleActionResult = handleAction("button", cls, text);
    handleActionResult.type = "button";
    handleActionResult.onclick = index;
    return handleActionResult;
  };
  function mount(root, session, options = {}) {
    const role = session?.tipo,
      numero = Number(options.institutionId || session?.data?.institution_id);
    const preview = role === "admin" && options.preview === true;
    if (!numero || (!preview && !["instituicao", "professor"].includes(role))) {
      root.textContent = "Entre novamente para abrir sua instituição.";
      return () => root.replaceChildren();
    }
    let alive = true,
      generation = 0,
      disposeView = null,
      institution = null,
      requestedKey = "home",
      loading = false,
      loadError = null,
      requestController = null;
    const matchMediaResult = matchMedia("(min-width:1101px)");
    const shell = handleAction("div", "dp-shell"),
      side = handleAction("aside", "dp-sidebar"),
      area = handleAction("div", "dp-area"),
      top = handleAction("header", "dp-topbar"),
      main = handleAction("main", "dp-main"),
      backdrop = btn("Fechar menu", () => setOpen(false), "dp-backdrop");
    const title = handleAction("h1", null, "Visão geral"),
      menu = btn(
        "☰",
        () => setOpen(!shell.classList.contains("dp-menu-open")),
        "dp-menu-button",
      );
    menu.setAttribute("aria-controls", "dp-navigation");
    menu.setAttribute("aria-label", "Abrir ou fechar navegação");
    shell.append(side, backdrop, area);
    area.append(top, main);
    root.replaceChildren(shell);
    const inertBefore = [];
    for (
      let child = root;
      child.parentElement && child.parentElement !== document.body;
      child = child.parentElement
    )
      for (const sibling of child.parentElement.children)
        if (sibling !== child) {
          inertBefore.push([sibling, sibling.inert]);
          sibling.inert = true;
        }
    const bodyOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const brand = handleAction("div", "dp-brand");
    brand.append(
      handleAction("strong", null, "Daniel Marlon"),
      handleAction("span", null, "REFORÇO ESCOLAR"),
    );
    side.append(brand);
    const person = handleAction("div", "dp-person"),
      avatar = handleAction("div", "dp-avatar"),
      personText = handleAction("div"),
      institutionName = handleAction("strong", null, "Carregando instituição…");
    personText.append(
      institutionName,
      handleAction(
        "span",
        null,
        role === "professor" ? "Portal do professor" : "Portal da instituição",
      ),
    );
    person.append(avatar, personText);
    side.append(person);
    function refreshAvatar() {
      avatar.replaceChildren();
      const pic = handleAction("img");
      pic.alt = "";
      pic.style.cssText =
        "width:100%;height:100%;object-fit:cover;border-radius:50%";
      pic.src = institution?.imagem
        ? sourceImage(institution.imagem)
        : "data:image/svg+xml," +
          encodeURIComponent(
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80"><rect width="80" height="80" rx="40" fill="#e7f3f1"/><path d="M19 59h42M24 59V28l16-10 16 10v31M35 59V43h10v16M33 30v5m14-5v5" fill="none" stroke="#4fb3a9" stroke-width="4"/></svg>',
          );
      avatar.append(pic);
    }
    const nav = handleAction("nav", "dp-nav");
    nav.id = "dp-navigation";
    nav.setAttribute("aria-label", "Navegação da instituição");
    side.append(nav);
    const navButtons = new Map();
    function allowed(key) {
      return (
        key === "home" ||
        (Array.isArray(institution?.management_screens) &&
          institution.management_screens.includes(screens[key]))
      );
    }
    function navItem(key) {
      const btnResult = btn(labels[key], () => navigate(key), "dp-nav-item");
      navButtons.set(key, btnResult);
      nav.append(btnResult);
    }
    nav.append(handleAction("div", "dp-nav-label", "MATERIAIS"));
    libraries.forEach(navItem);
    nav.append(handleAction("div", "dp-nav-label", "GESTÃO"));
    [
      "tarefas",
      ...(role !== "professor" ? ["pontuacao"] : []),
      "home",
      "alunos",
      "turmas",
      "relatorios",
      ...(role !== "professor"
        ? [
            "professores",
            "feed",
            "questoes",
            "bonus",
            "cardapio",
            "loja",
            "agendar",
            "desafios",
            "rankings",
            "meritos",
            "perfil",
          ]
        : []),
    ].forEach(navItem);
    const footer = handleAction("div", "dp-side-footer");
    footer.append(
      handleAction(
        "p",
        null,
        "Materiais para consulta. A edição é exclusiva da administração geral.",
      ),
    );
    footer.append(
      btn(
        preview ? "Voltar à administração" : "Sair",
        () => {
          if (preview) {
            dispose();
            options.returnTo?.();
          } else {
            sessionStorage.removeItem("auth_session");
            window.location.hash = "/login-aluno";
            window.location.reload();
          }
        },
        "dp-exit",
      ),
    );
    side.append(footer);
    const identity = handleAction(
      "span",
      "dp-role",
      preview
        ? "Visão da instituição"
        : role === "professor"
          ? "Professor"
          : "Instituição",
    );
    top.append(menu, title, identity);
    const live = handleAction("div", "dp-status");
    live.setAttribute("role", "status");
    live.hidden = true;
    area.append(live);
    function notice(text) {
      if (!alive) return;
      live.textContent = text;
      live.hidden = false;
    }
    function setOpen(open) {
      shell.classList.toggle("dp-menu-open", open);
      shell.classList.toggle("dp-menu-closed", !open);
      menu.setAttribute("aria-expanded", String(open));
      if (!matchMediaResult.matches) {
        backdrop.hidden = !open;
        side.inert = !open;
      } else {
        backdrop.hidden = true;
        side.inert = !open;
      }
    }
    const resize = () => setOpen(matchMediaResult.matches),
      escape = (value) => {
        if (value.key === "Escape" && !matchMediaResult.matches) {
          setOpen(false);
          menu.focus();
        }
      };
    matchMediaResult.addEventListener("change", resize);
    shell.addEventListener("keydown", escape);
    setOpen(matchMediaResult.matches);
    function renderLoadState() {
      if (loading) {
        main.replaceChildren(
          handleAction("p", "dp-loading", "Carregando instituição…"),
        );
        return;
      }
      if (!loadError) return;
      const error = handleAction("section", "dp-empty");
      error.setAttribute("role", "alert");
      error.append(handleAction("p", null, loadError.message));
      error.append(btn("Tentar novamente", load));
      if (loadError.status === 401)
        error.append(
          btn("Entrar novamente", () => {
            sessionStorage.removeItem("auth_session");
            window.location.hash = "/login-aluno";
            window.location.reload();
          }),
        );
      main.replaceChildren(error);
    }
    async function load() {
      if (!alive || loading) return;
      loading = true;
      loadError = null;
      institutionName.textContent = "Carregando instituição…";
      renderLoadState();
      const request = new AbortController();
      requestController = request;
      let timedOut = false;
      const timeout = setTimeout(() => {
        timedOut = true;
        request.abort();
      }, 15000);
      const headers = {};
      if (preview) {
        if (session.data?.token) headers["X-Admin-Token"] = session.data.token;
        if (session.data?.learning_admin_token)
          headers["X-Learning-Token"] = session.data.learning_admin_token;
      } else headers.Authorization = "Bearer " + session.data.access_token;
      try {
        const response = await fetch(
          getApiUrl(
            "/api/institutions.php?" +
              new URLSearchParams({
                resource: "portal",
                id: numero,
              }),
          ),
          {
            headers,
            signal: request.signal,
            credentials: "same-origin",
            cache: "no-store",
          },
        );
        let json;
        try {
          json = await response.json();
        } catch {
          throw Error("Não foi possível abrir a instituição. Tente novamente.");
        }
        if (!response.ok || json.status !== "success") {
          const error = Error(
            json.message || "Não foi possível abrir a instituição.",
          );
          error.status = response.status;
          throw error;
        }
        const data = json.data?.institution;
        if (
          !data ||
          Number(data.id) !== numero ||
          typeof data.nome !== "string" ||
          !data.nome.trim() ||
          !Array.isArray(data.management_screens)
        )
          throw Error("Não foi possível carregar os dados da instituição.");
        if (!alive) return;
        institution = data;
        loading = false;
        navButtons.forEach((button, key) => {
          button.hidden = !allowed(key);
        });
        institutionName.textContent = institution.nome;
        refreshAvatar();
        navigate(allowed(requestedKey) ? requestedKey : "home");
      } catch (error) {
        if (alive) {
          loading = false;
          loadError = {
            message: timedOut
              ? "A instituição demorou a responder. Tente novamente."
              : error.message || "Não foi possível abrir a instituição.",
            status: error.status,
          };
          institutionName.textContent = "Acesso indisponível";
          renderLoadState();
        }
      } finally {
        clearTimeout(timeout);
        if (requestController === request) requestController = null;
      }
    }
    function rowList(parent, entries) {
      const list = handleAction("div", "dp-links");
      for (const [name, detail, key] of entries) {
        if (!allowed(key)) continue;
        const row = btn("", () => navigate(key), "dp-link-row");
        const copy = handleAction("div");
        copy.append(
          handleAction("strong", null, name),
          handleAction("span", null, detail),
        );
        row.append(copy, handleAction("span", "dp-arrow", "→"));
        list.append(row);
      }
      parent.append(list);
    }
    function overview() {
      const intro = handleAction("section", "dp-intro");
      intro.append(
        handleAction(
          "div",
          "dp-eyebrow",
          role === "professor"
            ? "ENSINAR COM MAIS CLAREZA"
            : "SEU ESPAÇO DE ENSINO",
        ),
        handleAction("h2", null, institution.nome),
        handleAction(
          "p",
          null,
          role === "professor"
            ? "Encontre aulas, provas e atividades para apoiar seu trabalho com os alunos."
            : "Acompanhe sua instituição e encontre os materiais para apoiar professores e alunos.",
        ),
      );
      main.append(intro);
      if (preview)
        main.append(
          handleAction(
            "div",
            "dp-preview",
            "Você está na visão da instituição. Sua conta continua sendo de administrador geral.",
          ),
        );
      if (role !== "professor") {
        const metrics = handleAction("section", "dp-summary");
        metrics.setAttribute("aria-label", "Resumo da instituição");
        for (const [label, value, note] of [
          ["Alunos", institution.students_count ?? 0, "Cadastros vinculados"],
          [
            "Alunos ativos",
            institution.active_students_count ?? 0,
            "Acessos ativos",
          ],
          [
            "Professores",
            institution.teachers_count ?? 0,
            "Contas da instituição",
          ],
        ]) {
          const item = handleAction("div");
          item.append(
            handleAction("span", null, label),
            handleAction("strong", null, value),
            handleAction("small", null, note),
          );
          metrics.append(item);
        }
        main.append(metrics);
      }
      const materials = handleAction("section", "dp-section");
      materials.append(
        handleAction(
          "div",
          "dp-section-heading",
          "Materiais para ensinar e estudar",
        ),
      );
      rowList(materials, [
        ["Reforço", "Aulas, videoaulas, resumos e atividades", "reforco"],
        ["Vestibulares", "Provas e materiais de preparação", "vestibulares"],
        [
          "Simuladores",
          "Recursos interativos para explorar conceitos",
          "simuladores",
        ],
        ["Olimpíadas", "Preparação organizada por olimpíada", "olimpiadas"],
      ]);
      main.append(materials);
      {
        const management = handleAction("section", "dp-section");
        management.append(
          handleAction("div", "dp-section-heading", "Sua instituição"),
        );
        rowList(management, [
          ["Alunos", "Consulte a atividade de cada aluno", "alunos"],
          ["Turmas", "Consulte a atividade de cada turma", "turmas"],
          ["Tarefas", "Envie atividades e acompanhe as entregas", "tarefas"],
          [
            "Relatórios",
            "Acompanhamento individual e das turmas",
            "relatorios",
          ],
          ...(role !== "professor"
            ? [
                [
                  "Professores",
                  "Cadastre e acompanhe seus professores",
                  "professores",
                ],
              ]
            : []),
        ]);
        main.append(management);
      }
    }
    function pending(key) {
      const card = handleAction("section", "dp-feature");
      card.append(
        handleAction("div", "dp-eyebrow", "SUA INSTITUIÇÃO"),
        handleAction("h2", null, labels[key]),
      );
      const copy = {
        pontuacao: "Acompanhe a pontuação dos alunos desta instituição.",
        turmas: "Organize os alunos em turmas dentro desta instituição.",
      };
      card.append(
        handleAction("p", null, copy[key]),
        handleAction(
          "div",
          "dp-coming",
          "A gestão desta área estará disponível na próxima etapa.",
        ),
      );
      main.append(card);
    }
    function navigate(key) {
      if (!alive || !Object.hasOwn(labels, key) || !allowed(key)) return;
      if (
        role === "professor" &&
        ![
          "home",
          "tarefas",
          "relatorios",
          "alunos",
          "turmas",
          ...libraries,
        ].includes(key)
      )
        return;
      ++generation;
      disposeView?.();
      disposeView = null;
      main.replaceChildren();
      live.hidden = true;
      title.textContent = labels[key] || "Alunos e turmas";
      navButtons.forEach((item, index) => {
        item.classList.toggle(
          "dp-selected",
          index === (key === "cadastro" ? "alunos" : key),
        );
        if (index === (key === "cadastro" ? "alunos" : key))
          item.setAttribute("aria-current", "page");
        else item.removeAttribute("aria-current");
      });
      if (!matchMediaResult.matches) setOpen(false);
      main.scrollTop = 0;
      requestedKey = key;
      if (!institution) {
        renderLoadState();
        return;
      }
      if (key === "home") return overview();
      if (libraries.includes(key)) {
        const content = handleAction("div", "dp-library");
        main.append(content);
        if (window.DMInstitutionLibrary)
          disposeView = window.DMInstitutionLibrary.mount(
            content,
            key,
            notice,
            session,
            numero,
          );
        else content.textContent = "Atualize a página para abrir os materiais.";
        return;
      }
      if (key === "alunos" && role !== "professor") {
        const content = handleAction("div", "dp-original-students");
        main.append(content);
        if (window.DMInstitutionStudents)
          disposeView = window.DMInstitutionStudents.mount(
            content,
            session,
            numero,
            {
              notify: notice,
              onStudentRecord: (sid) => {
                disposeView?.();
                content.replaceChildren();
                disposeView = window.DMSchool.mount(
                  content,
                  session,
                  numero,
                  "alunos",
                  {
                    screens: institution.management_screens,
                    studentId: sid,
                    onBack: () => navigate("alunos"),
                  },
                );
              },
            },
          );
        else content.textContent = "Atualize a página para abrir os alunos.";
        return;
      }
      if (["alunos", "turmas", "tarefas", "relatorios"].includes(key)) {
        const content = handleAction("div");
        main.append(content);
        disposeView = window.DMSchool.mount(content, session, numero, key, {
          screens: institution.management_screens,
          onRegisterStudent: null,
        });
        return;
      }
      if (key === "professores" || key === "pontuacao") {
        const content = handleAction("div");
        main.append(content);
        const module =
          key === "professores"
            ? window.DMInstitutionTeachers
            : window.DMInstitutionPoints;
        if (module)
          disposeView = module.mount(content, session, numero, {
            notify: notice,
          });
        else content.textContent = "Atualize a página para abrir esta área.";
        return;
      }
      if (key === "perfil" && role !== "professor") {
        const content = handleAction("div");
        main.append(content);
        disposeView = window.DMInstitutionProfile.mount(
          content,
          session,
          numero,
          {
            onSaved: (value) => {
              institution.imagem = value.imagem;
              refreshAvatar();
              notice("Perfil da instituição atualizado.");
            },
          },
        );
        return;
      }
      if (
        [
          "feed",
          "questoes",
          "cardapio",
          "loja",
          "meritos",
          "rankings",
          "desafios",
          "agendar",
        ].includes(key) &&
        role !== "professor"
      ) {
        const content = handleAction("div");
        main.append(content);
        if (key === "loja")
          main.prepend(btn("Ver resgates", () => navigate("resgates")));
        disposeView = window.DMInstitutionNative.mount(
          content,
          session,
          numero,
          key,
          {
            notify: notice,
            onStudent: (sid) => {
              if (!allowed("alunos"))
                return notice(
                  "A consulta de alunos não está liberada para esta instituição.",
                );
              disposeView?.();
              content.replaceChildren();
              disposeView = window.DMSchool.mount(
                content,
                session,
                numero,
                "alunos",
                {
                  screens: institution.management_screens,
                  studentId: sid,
                  onBack: () => navigate(key),
                },
              );
            },
          },
        );
        return;
      }
      if (
        [
          "feed",
          "questoes",
          "bonus",
          "cardapio",
          "loja",
          "salas",
          "bloqueios",
          "agendar",
          "desafios",
          "resgates",
          "meritos",
        ].includes(key) &&
        role !== "professor"
      ) {
        const content = handleAction("div");
        main.append(content);
        disposeView = window.DMInstitutionOperations.mount(
          content,
          session,
          numero,
          key,
          {
            navigate,
            notify: notice,
          },
        );
        return;
      }
      pending(key);
    }
    function dispose() {
      if (!alive) return;
      alive = false;
      ++generation;
      requestController?.abort();
      disposeView?.();
      matchMediaResult.removeEventListener("change", resize);
      shell.removeEventListener("keydown", escape);
      for (const [optionalValue, before] of inertBefore)
        if (optionalValue.isConnected) optionalValue.inert = before;
      document.body.style.overflow = bodyOverflow;
      root.replaceChildren();
    }
    load();
    return dispose;
  }
  window.DMInstitutionPortal = Object.freeze({
    mount,
  });
  window.DMInstitutions.mountPortal = (root, session) => mount(root, session);
})();
